module.exports = __webpack_public_path__ + "static/media/elevid-logo-header.92ad9dc8.svg";